// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1mvJN","rightAdornment":"Header_rightAdornment__Z71ls"};